import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/reg',
      name: 'reg',
      component: () => import('../views/Reg.vue')
    },
    {
      path: '/estado',
      name: 'estado',
      component: () => import('../views/Estado.vue'),
      meta: { rutaProtegida: true }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'nofound',
      component: () => import('../views/Reg.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Al recargar, el estado se pierde pero la sesion sigue viva en Firebase
  // Authentication: la pantalla de entrada la recupera y vuelve a /estado.
  if (to.meta.rutaProtegida && !store.state.codigo) return next('/reg')
  next()
})

export default router
